module.exports = __webpack_public_path__ + "img/10551394_L.c95d2dee.png";